import { render } from "./MasterDataRowsForm.vue?vue&type=template&id=58787183&ts=true"
import script from "./MasterDataRowsForm.vue?vue&type=script&lang=ts"
export * from "./MasterDataRowsForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__